export function parseColor (color) {
  if (Array.isArray(color) && (color.length === 3 || color.length === 4)) {
    return color
  }

  if (color.startsWith('rgb')) {
    color = color.replace('rgb(', '')
    color = color.replace(')', '')
    let [r, g, b] = color.split(',')
    r /= 255
    g /= 255
    b /= 255
    return [r, g, b]
  } else {
    console.error('Color format not supported')
  }

  return [0, 0, 0]
}

export function rgbToHsl ([r, g, b]) {
  const l = Math.max(r, g, b)
  const s = l - Math.min(r, g, b)
  const h = s
    ? l === r
      ? (g - b) / s
      : l === g
        ? 2 + (b - r) / s
        : 4 + (r - g) / s
    : 0
  const res = [
    60 * h < 0 ? 60 * h + 360 : 60 * h,
    100 * (s ? (l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s))) : 0),
    (100 * (2 * l - s)) / 2
  ]
  return res
}

export function darkenColor (color) {
  color = rgbToHsl(parseColor(color))
  color[0] = Math.min(Math.max(color[0] + 2, 0), 360)
  color[1] = Math.min(Math.max(color[1] - 64, 0), 100)
  color[2] = Math.min(Math.max(color[2] - 25, 0), 100)
  return `hsl(${color[0]}, ${color[1]}%, ${color[2]}%)`
}

export function lightenColor (color) {
  color = rgbToHsl(parseColor(color))
  color[0] = Math.min(Math.max(color[0] - 2, 0), 360)
  color[1] = Math.min(Math.max(color[1] + 34, 0), 100)
  color[2] = Math.min(Math.max(color[2] + Math.floor((100 - color[2]) * 0.8), 0), 100)
  return `hsl(${color[0]}, ${color[1]}%, ${color[2]}%)`
}

export function selectForegroundColor (red, green, blue) {
  if ((red * 0.299 + green * 0.587 + blue * 0.114) > 186) {
    return '#000000'
  } else {
    return '#ffffff'
  }
}
